const metrics = {
  port: 9091,
  host: '0.0.0.0',
  path: '/metrics',
};

export default metrics;
